import React from "react";
import { motion } from "framer-motion";

const PartnerNetwork = () => {
  const stats = [
    { label: "Strategic Partners", value: "2+" },
    { label: "Strategies Integrated", value: "12+" },
    { label: "Custodial Connections", value: "1" },
    { label: "Cumulative On-Chain Volume", value: "$1B+" },
  ];

  return (
    <section className="relative py-28 bg-gradient-to-b from-[#0A2A66] via-[#081B3F] to-[#050B1A] text-white text-center overflow-hidden">
      {/* Glow effect */}
      <div className="absolute inset-0">
        <div className="absolute top-0 left-1/3 w-[600px] h-[600px] bg-[radial-gradient(circle,rgba(77,178,211,0.25),transparent_70%)] blur-3xl"></div>
      </div>

      <div className="relative z-10 max-w-5xl mx-auto px-6">
        <motion.h2
          className="text-3xl md:text-5xl font-bold mb-10"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7 }}
        >
          Join Our Expanding Network
        </motion.h2>
        <p className="text-white/80 max-w-3xl mx-auto mb-12">
          QuantNexus Capital partners with strategic funds, innovators, and technology providers to redefine capital efficiency across decentralized markets.
B\        Become part of the infrastructure layer bridging traditional and on-chain finance.
        </p>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 mb-16">
          {stats.map((s, i) => (
            <motion.div
              key={i}
              className="p-6 bg-white/5 border border-white/10 rounded-2xl backdrop-blur-md"
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: i * 0.1 }}
            >
              <p className="text-3xl font-bold text-[#4DB2D3] mb-1">{s.value}</p>
              <p className="text-sm text-white/70">{s.label}</p>
            </motion.div>
          ))}
        </div>

        <motion.a
          href="#contact"
          className="inline-block px-8 py-4 rounded-full bg-gradient-to-r from-[#4DB2D3] to-[#3D8FAA] font-semibold text-black shadow-lg hover:scale-105 transition-transform"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.2 }}
        >
          Become a QNC Partner
        </motion.a>
      </div>
    </section>
  );
};

export default PartnerNetwork;
